import { get, post, remove } from './api';
import routes from './end-points';
export const bankAccountsApi = {
  initMyAccounts: () => get(routes.bankAccounts.initMyAccounts),
  saveChanges: (dto) => post(routes.bankAccounts.saveChanges, dto),
  delete: (id) => remove(routes.bankAccounts.delete(id)),

  initByAdmin: (userId) => get(`${routes.bankAccounts.byAdmin}?userId=${userId}`),
  saveByAdmin: (userId, bankAccount) => post(`${routes.bankAccounts.byAdmin}?userId=${userId}`, bankAccount),
  deleteByAdmin: (userId, id) => remove(`${routes.bankAccounts.byAdmin}?userId=${userId}&bankAccountId=${id}`),
};
